import api from "./axios";

class ServiceSupportArt {
  async unlock(password) {
    await api.post("/support/prescription-art/unlock", { password });
  }

  async search(password, oldArt) {
    const { data } = await api.post("/support/prescription-art/search", {
      password,
      oldArt,
    });
    return data;
  }

  async replace(password, oldArt, newArt, expectedCount) {
    const { data } = await api.post("/support/prescription-art/replace", {
      password,
      oldArt,
      newArt,
      expectedCount,
    });
    return data;
  }
}

export default new ServiceSupportArt();
